import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { AuthService, CenterPhoneService } from "../../services";
import { Spinner, Breadcrumb, BreadcrumbItem, Tabs, Tab } from "react-bootstrap";
import { useUnsavedChangesGuard, useFormDirtyTracker } from "../../shared";

const CreateCenterPhone = () => {
  const navigate = useNavigate();
	const [phoneTitle, setPhoneTitle] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
  const params = new URLSearchParams(window.location.search);

  const { isDirty, resetBaseline } = useFormDirtyTracker({ phoneTitle, phoneNumber });
  const { tryNavigate, tryGoBack } = useUnsavedChangesGuard(isDirty);

  useEffect(() => {
    if (!AuthService.canAddOrEditRoutes() && !AuthService.canViewRoutes()&&!AuthService.canAccessLegacySystem()) {
      window.alert('You haven\'t login yet OR this user does not have access to this page. Please change an Dispatcher or admin account to login.')
      AuthService.logout();
      navigate(`/login`);
    }
  }, []);


  const goBack = () => {
    tryGoBack(`/center-phones/list`);
  };

	const validatePhone = () => {
		const errors = [];
		
		// Required fields validation
		if (!phoneTitle || phoneTitle.trim() === '') {
			errors.push('Phone Title');
		}
		if (!phoneNumber || phoneNumber.trim() === '') {
			errors.push('Phone Number');
		}
		
		if (errors.length > 0) {
			window.alert(`Please fill in the following required fields:\n${errors.join('\n')}`);
			return false;
		}
		return true;
	};

	const savePhone = () => {
		if (!validatePhone()) {
			return;
		}
		
		const data = {
			phone_title: phoneTitle,
			phone_number: phoneNumber
		};
		CenterPhoneService.createNewCenterPhone(data).then(() => {
			resetBaseline();
			tryNavigate(`/center-phones/list`);
		});
	}

  
  return (
    <>
      <div className="list row mb-4">
        <Breadcrumb>
          <Breadcrumb.Item href="/">General</Breadcrumb.Item>
          <Breadcrumb.Item href="/center-phones/list">
            Center Phone 
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            Create Center Phone
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-md-12 text-primary">
           <h4>
             Create Center Phone <button className="btn btn-link btn-sm" onClick={() => {goBack()}}>Back</button>
           </h4> 
        </div>
      </div>

      <div className="app-main-content-list-container">
				<div className="app-main-content-list-func-container">
					<Tabs defaultActiveKey="phoneCreation" id="phone-creation-tab">
						<Tab eventKey="phoneCreation" title="Create Center Phone">
              <div className="app-main-content-fields-section">
								<div className="me-4">
									<div className="field-label">Phone Title
										<span className="required">*</span>
									</div>
									<input type="text" value={phoneTitle || ''} onChange={e => setPhoneTitle(e.target.value)}/>
								</div>
                <div className="me-4">
									<div className="field-label">Phone Number
										<span className="required">*</span>
									</div>
									<input type="text" value={phoneNumber || ''} onChange={e => setPhoneNumber(e.target.value)}/>
								</div>
              </div>
              <div className="col-md-12 col-sm-12 col-xs-12">
								<button className="btn btn-default btn-sm float-right" onClick={() => goBack()}> Cancel </button>
								<button className="btn btn-primary btn-sm float-right" onClick={() => savePhone()}> Save </button>
								
							</div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default CreateCenterPhone;